import { datadogRum } from '@datadog/browser-rum';

export function reportError(
  name: string,
  data?: unknown,
  context?: Record<string, unknown>
) {
  if (typeof window === 'undefined') return;

  if (data instanceof Error) {
    datadogRum.addError(data, { ...context, logger: { name } });
  } else {
    datadogRum.addError(new Error(name), {
      ...context,
      logger: { name, data },
    });
  }
}
